<script lang="ts">
  import { onDestroy } from 'svelte';
  import { api, navigate } from '../lib/api';
  import { router } from '../lib/router.svelte';
  import type { Overview } from './admin/types';
  import Dashboard from './admin/Dashboard.svelte';
  import Sources from './admin/Sources.svelte';
  import Positions from './admin/Positions.svelte';
  import Tally from './admin/Tally.svelte';
  import Audio from './admin/Audio.svelte';
  import Outputs from './admin/Outputs.svelte';
  import Users from './admin/Users.svelte';
  import ConfigIO from './admin/ConfigIO.svelte';

  const tabs = [
    ['dashboard', 'Dashboard'],
    ['sources', 'Sources'],
    ['positions', 'Positions & links'],
    ['tally', 'Tally'],
    ['audio', 'Audio I/O'],
    ['outputs', 'Outputs'],
    ['users', 'Users'],
    ['config', 'Import / export'],
  ] as const;
  const tab = $derived(router.path.split('/')[2] || 'dashboard');

  let data = $state<Overview | null>(null);
  let error = $state<string | null>(null);

  async function reload() {
    try {
      data = await api.get<Overview>('/api/admin/overview');
      error = null;
    } catch (err) {
      error = (err as Error).message;
    }
  }
  void reload();
  const timer = setInterval(reload, 2000);
  onDestroy(() => clearInterval(timer));
</script>

<div class="page">
  <div class="row head">
    <h1 class="grow">Admin</h1>
    {#if data?.dev}<span class="badge warn">DEV MODE</span>{/if}
    <button onclick={() => navigate('/director')}>Director</button>
    <button onclick={() => navigate('/join')}>Cameras</button>
  </div>
  <nav class="row">
    {#each tabs as [id, label] (id)}
      <button class:active={tab === id} onclick={() => navigate(`/admin/${id}`)}>{label}</button>
    {/each}
  </nav>
  {#if error}<p class="error">{error}</p>{/if}
  {#if data}
    {#if tab === 'dashboard'}<Dashboard {data} {reload} />
    {:else if tab === 'sources'}<Sources {data} {reload} />
    {:else if tab === 'positions'}<Positions {data} {reload} />
    {:else if tab === 'tally'}<Tally {data} {reload} />
    {:else if tab === 'audio'}<Audio {data} {reload} />
    {:else if tab === 'outputs'}<Outputs {data} {reload} />
    {:else if tab === 'users'}<Users {data} {reload} />
    {:else if tab === 'config'}<ConfigIO {reload} />
    {/if}
  {:else}
    <p class="muted">Loading…</p>
  {/if}
</div>

<style>
  .head { margin-bottom: 8px; }
  .head h1 { margin: 0; }
  nav { margin-bottom: 16px; }
  :global(.admin-grid) { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); gap: 12px; }
  :global(.form) { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 10px; align-items: end; }
  :global(.form .wide) { grid-column: 1 / -1; }
  :global(.list-item) { display: flex; gap: 10px; align-items: center; padding: 8px 0; border-bottom: 1px solid var(--line); flex-wrap: wrap; }
</style>
